import React from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';

import SingleQuestionForm from './SingleQuestionForm';
import { questionLayoutPropType } from '../../config/richTextConfig/questionLayout';
import TextQuestionRichText from '../../domains/richText/components/TextQuestionRichText';
import convertToPlainAnswer from './utils/convertToPlainAnswer';
import convertFromPlainAnswer from './utils/convertFromPlainAnswer';
import propTypeBlockStyling from '../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class SingleQuestion extends React.Component {
  static propTypes = {
    block: PropTypes.shape({
      clientUuid: PropTypes.string.isRequired,
      required: PropTypes.bool,
      content: PropTypes.object,
    }).isRequired,
    isCloned: PropTypes.bool,
    isInPreviewMode: PropTypes.bool,
    onAnswer: PropTypes.func.isRequired,
    layout: questionLayoutPropType,
    answer: PropTypes.shape({
      value: PropTypes.string,
      id: PropTypes.string,
      comments: PropTypes.string,
    }),
    styling: propTypeBlockStyling,
    questionNumber: PropTypes.number,
  };

  handleSubmit = (answer) => {
    this.props.onAnswer(convertToPlainAnswer(answer));
  };

  render = () => {
    const {
      block,
      block: { clientUuid, required, content },
      answer,
      layout,
      styling,
      questionNumber,
      isCloned,
      isInPreviewMode = false,
    } = this.props;

    const isConditionalQuestion = !!(block.logic && block.logic.message);

    return (
      <div>
        {isInPreviewMode &&
          isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
        <TextQuestionRichText
          questionNumber={questionNumber}
          layout={layout}
          content={content}
          required={required}
          styling={styling}
        />
        <SingleQuestionForm
          form={generateQuestionFormName(clientUuid, isCloned)}
          layout={layout}
          block={block}
          onSubmit={this.handleSubmit}
          initialValues={convertFromPlainAnswer(answer)}
          styling={styling}
        />
      </div>
    );
  };
}

export default SingleQuestion;
